import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFilterFieldProps } from '../form/types';
import { useTheme } from '@mc/react-theme-context';
import classNames from 'classnames';
import { DateInput } from '../datetime/DateInput';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { DATA_FILTER_INPUT } from '../common/data';

export type DateProps = Omit<
  VFFilterFieldProps<React.ComponentProps<typeof DateInput> & FilterFieldProps>,
  'value'
>;
export const FilterDate = React.forwardRef<HTMLInputElement, DateProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      disabled,
      filterType,
      size = 5,
      extendedFilter,
      ...other
    },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field name={getFilterFieldFormValuePath(name, filterType)}>
          {({ input: { value, onChange }, meta }: FieldRenderProps<any>) => {
            return (
              <DateInput
                {...DATA_FILTER_INPUT(name)}
                {...other}
                inputProps={{ size }}
                disabled={disabled || meta.submitting}
                className={classNames(
                  `${ns}-date final-form-input-right-visual`,
                  inputClassName
                )}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
